import React from 'react'

const DesktopMenuSkeleton = () => (
  <div className="ml-auto hidden animate-pulse items-center gap-4 lg:flex">
    {Array.from(Array(7).keys()).map(index => (
      <div key={index} className="bg-text-secondary h-5 w-16 rounded-sm" />
    ))}
  </div>
)

export default DesktopMenuSkeleton
